import { render, staticRenderFns } from "./Entry.vue?vue&type=template&id=3b7854a2&scoped=true"
import script from "./Entry.vue?vue&type=script&lang=js"
export * from "./Entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7854a2",
  null
  
)

export default component.exports